import { combineReducers } from 'redux';
import activePathReducer from './activePathReducer';
import alertReducer from './alertReducer';
import elementReducer from './elementReducer';
import elementTemplateReducer from './elementTemplateReducer';
import formReducer from './formReducer';
import modalReducer from './modalReducer';
import projectReducer from './projectReducer';
import protoTypeReducer from './prototypeReducer';
import rowReducer from './rowReducer';
import sectionReducer from './sectionReducer';
import sessionReducer from './sessionReducer';
import tabReducer from './tabReducer';

const RootReducer = combineReducers({
    projectList: projectReducer,
    formList: formReducer,
    rowList: rowReducer,
    sectionList: sectionReducer,
    elementList : elementReducer,
    tabList: tabReducer,
    session: sessionReducer,
    elementTemplateList: elementTemplateReducer,
    protoType:protoTypeReducer,
    alert:alertReducer,
    modal:modalReducer,
    active:activePathReducer,
});

export type AppState = ReturnType<typeof RootReducer>

export default RootReducer